// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ZynU","label":"Category_label__eovx2","content":"Category_content__2h8-k","header":"Category_header__q3q5D","location":"Category_location__23atO"};